import { ButtonLink } from "design-system/atoms/Button"

import { Outlet } from "@tanstack/react-router"
import { BadgePingText } from "design-system/molecules/BadgePingText"
import { Card, CardDescription, CardHeader, CardTitle } from "design-system/molecules/Card"
import { Pencil } from "lucide-react"
import { useGorgiasIntegrationQuery } from "modules/settings/hooks/gorgias/useGorgiasIntegrationQuery"
import { Loading } from "modules/shared/components/Loading"
import { useTranslation } from "react-i18next"

export const GorgiasIntegration = () => {
  const { t } = useTranslation()
  const { data, isPending } = useGorgiasIntegrationQuery()

  if (isPending) {
    return <Loading />
  }

  const hasConfiguration = !!data

  return (
    <>
      <Card>
        <CardHeader className="flex flex-row gap-4 p-4">
          <div className="grow flex flex-col gap-1">
            <CardTitle>{t("settings.integrations.gorgias.integrationCard.title")}</CardTitle>
            <CardDescription>
              {hasConfiguration
                ? t("settings.integrations.gorgias.integrationCard.descriptionDone")
                : t("settings.integrations.gorgias.integrationCard.descriptionPending")}
            </CardDescription>
          </div>
          <div className="flex items-center">
            {hasConfiguration ? (
              <div className="flex gap-2">
                <BadgePingText
                  color={"success"}
                  text={t("settings.integrations.gorgias.integrationCard.connected")}
                />
                <ButtonLink
                  variant={"ghost"}
                  size="icon"
                  to="/settings/integrations/gorgias/connect"
                >
                  <Pencil />
                </ButtonLink>
              </div>
            ) : (
              <ButtonLink to={"/settings/integrations/gorgias/connect"}>
                {t("settings.integrations.gorgias.integrationCard.configButton")}
              </ButtonLink>
            )}
          </div>
        </CardHeader>
      </Card>
      <Outlet />
    </>
  )
}
